<!-- Service Start -->
<section class="section" id="services">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-lg-6 col-md-8">
                <div class="title text-center mb-5">
                    <h3 class="font-weight-normal text-dark">Nuestros <span class="text-warning">Servicios</span></h3>
                    <div class="card-heig">
                        <p class="text-muted">Nos especializamos en técnologias de la información y desarrollo de software a la medida en todas las plataformas.</p>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-lg-4 col-md-6">
                <div class="service-box service-warning">
                    <div class="mb-5">
                        <i class="pe-7s-browser service-icon"></i>
                    </div>
                    <h5 class="service-title text-dark font-weight-normal pt-1 mb-4">Desarrollo de Sitios Web</h5>
                    <div class="card-heig" >
                        <p class="text-muted service-subtitle mb-4">Desarrolo de páginas web para todo tipo de negocios. Usando Tecnologias como React, Angular, HTML, etc.</p>
                    </div>
                    <a  class="btn btn-light" [ngxScrollTo]="'#contac'" [ngxScrollToOffset]="2" href="javascript: void(0)">Más Información</a>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="service-box service-warning">
                    <div class="mb-5">
                        <i class="pe-7s-network service-icon"></i>
                    </div>
                    <h5 class="service-title text-dark font-weight-normal pt-1 mb-4">Aplicaciones Multiplataforma</h5>
                    <div class="card-heig">
                        <p class="text-muted service-subtitle mb-4">Aplicaciones nativas para plataformas como: Mac, Windows y Linux. No importa cuál sea tu necesidad, nuestro desarrollo coorerá en cualquier plataforma.</p>
                    </div>
                    <a  class="btn btn-light" [ngxScrollTo]="'#contac'" [ngxScrollToOffset]="2" href="javascript: void(0)">Más Información</a>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="service-box service-warning">
                    <div class="mb-5">
                        <i class="pe-7s-phone service-icon"></i>
                    </div>
                    <h5 class="service-title text-dark font-weight-normal pt-1 mb-4">Aplicaciones Móviles</h5>
                    <div class="card-heig">
                        <p class="text-muted service-subtitle mb-4">Desarrollo de complejas aplicaciones móviles para plataformas como Andoid, iOS y Armony OS, Completamente personalisables para cubrir cada necesidad.</p>
                    </div>
                    <a  class="btn btn-light" [ngxScrollTo]="'#contac'" [ngxScrollToOffset]="2" href="javascript: void(0)">Más Información</a>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="service-box service-warning">
                    <div class="mb-5">
                        <i class="pe-7s-cart service-icon"></i>
                    </div>
                    <h5 class="service-title text-dark font-weight-normal pt-1 mb-4">E-commerce a la Medida</h5>
                    <div class="card-heig">
                        <p class="text-muted service-subtitle mb-4">Puedes vender tus productos y servicios 24/7, con nuestra platafoma de e-commerce tendras las mejores oportunidades de colocar tus productos o servicios donde quieras!.</p>
                    </div>
                    <a  class="btn btn-light" [ngxScrollTo]="'#contac'" [ngxScrollToOffset]="2" href="javascript: void(0)">Más Información</a>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="service-box service-warning">
                    <div class="mb-5">
                        <i class="pe-7s-light service-icon"></i>
                    </div>
                    <h5 class="service-title text-dark font-weight-normal pt-1 mb-4">Análisis de Gestión</h5>
                    <div class="card-heig">
                        <p class="text-muted service-subtitle mb-4">Servicio donde se analiza los recursos disponibles, como mejorarlos y ser mas eficiente. Tambien se valora la implementación de nuevas herramientas para optimizar el trabajo actual.</p>
                    </div>
                    <a  class="btn btn-light" [ngxScrollTo]="'#contac'" [ngxScrollToOffset]="2" href="javascript: void(0)">Más Información</a>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="service-box service-warning">
                    <div class="mb-5">
                        <i class="pe-7s-graph1 service-icon"></i>
                    </div>
                    <h5 class="service-title text-dark font-weight-normal pt-1 mb-4">Estadísticas y Manejo de Datos</h5>
                    <div class="card-heig">
                        <p class="text-muted service-subtitle mb-4">Elaboración de reportes y estadistica en base a los datos de la empresa. Con esta información se pueden tomar desiciones y valorar el rendimiento historico de ciertas áreas.</p>
                    </div>
                    <a  class="btn btn-light" [ngxScrollTo]="'#contac'" [ngxScrollToOffset]="2" href="javascript: void(0)">Más Información</a>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- Service End -->